import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChild, ElementRef, Input } from '@angular/core';
import { TableColumn } from '../../../models/table-column.model';

@Component({
  selector: 'cosmos-row',
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RowComponent<T extends { id?: string }> implements AfterContentInit {
  @Input() item: T;
  @Input() columns: TableColumn[];
  @Input() missingValueMessageKey = 'general.unknown-value';
  @Input() missingValueIcon = 'help';
  @Input() showDetails = false;

  @ContentChild('details') details: ElementRef;

  public hasDetails = false;

  public ngAfterContentInit(): void {
    this.hasDetails = !!this.details;
  }

  public toggleDetails(): void {
    if (this.hasDetails) {
      this.showDetails = !this.showDetails;
    }
  }
}
